import type React from 'react';
import { useTranslation } from 'react-i18next';

import { magnifiedImageSize } from '../../helpers/boxGeometry';
import type { ImageSize } from '../../types';

import styles from './Magnifier.module.scss';

export interface MagnifierProps {
    path: string;
    dimensions: ImageSize;
    magnifierOn?: boolean;
    isColor?: boolean;
}

export default function Magnifier(props: MagnifierProps) {
    const { path, dimensions, magnifierOn = false, isColor = true } = props;
    const { t } = useTranslation();

    /* Must match the --salmon-width/--salmon-height that ImageStage writes on the figure:
       the CSS positions this image by offsetting it a fraction of those, which is only the
       right offset if the image really is that size. Hence the shared helper. */
    const magnified = magnifiedImageSize(dimensions, isColor);

    const compensatedImageStyle: React.CSSProperties = magnifierOn
        ? {
              width: `${magnified.width}px`,
              height: `${magnified.height}px`,
          }
        : {};

    return (
        <div
            className={styles.magnifyer}
            style={{ visibility: magnifierOn ? 'visible' : 'hidden' }}>
            <img style={compensatedImageStyle} src={path} alt={t('organisms.magnifier.alt')} />
        </div>
    );
}
